import { ImageResource } from './ImageResource';
import { ResourceDataType } from 'features/pi/services/AssistantDTOs';
import { IResource } from 'features/pi/model/resources/Resource';
import { PiError } from 'features/pi/model/pi-errors/PiError';

export interface IResourceFactory {
    createResource(type: ResourceDataType, data: unknown): IResource;
}

export class ResourceFactory implements IResourceFactory {
    createResource(type: ResourceDataType, data: unknown): IResource {
        let resource: IResource;
        switch (type) {
            case 'image_url':
                resource = new ImageResource({
                    type,
                    data: data as string,
                });
                break;
            default:
                throw new PiError(`unknown Resource type: ${type}`);
        }

        return resource;
    }
}
